import type { ReactNode } from 'react';
import './form.css';

interface TegelKiezerProps<T extends string> {
  label: string;
  waarde: T | '';
  opties: readonly T[];
  bijWijziging: (waarde: T) => void;
  /** Icoon per optie, alleen waar het onderscheid maakt. */
  iconen?: Partial<Record<T, ReactNode>>;
}

/**
 * Keuze als grote tegels in plaats van een uitklaplijst.
 *
 * Buiten, met een telefoon in één hand, is aantikken sneller en zekerder dan
 * scrollen door een lijst. De gekozen tegel slaat helemaal om van kleur; een
 * randje van twee pixels is in de zon niet te zien.
 */
export function TegelKiezer<T extends string>({
  label,
  waarde,
  opties,
  bijWijziging,
  iconen,
}: TegelKiezerProps<T>): JSX.Element {
  return (
    <div className="veld">
      <span className="veld__label">{label}</span>
      <div className="tegelkiezer" role="radiogroup" aria-label={label}>
        {opties.map((optie) => {
          const actief = optie === waarde;
          return (
            <button
              key={optie}
              type="button"
              role="radio"
              aria-checked={actief}
              className={`tegelkiezer__optie${actief ? ' tegelkiezer__optie--actief' : ''}`}
              onClick={() => bijWijziging(optie)}
            >
              {iconen?.[optie] && <span className="tegelkiezer__icoon">{iconen[optie]}</span>}
              {optie}
            </button>
          );
        })}
      </div>
    </div>
  );
}
